var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 306,
    viewBox: "0 0 266 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.57 78.7008C165.794 97.708 161.014 114.61 152.191 130.127C139.298 152.797 120.86 168.805 97.5327 177.89C79.0401 185.101 48.5833 196.263 25.6655 204.569C11.7619 209.617 -2.19634 197.099 0.289373 181.784C2.52925 168.026 5.04228 153.114 6.87242 143.423C7.41873 140.51 10.1776 136.703 12.7179 135.722C62.6234 116.888 112.638 98.4002 162.626 79.8545C163.827 79.4219 165.111 79.2488 167.542 78.672L167.57 78.7008Z",
    fill: "#00C271"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6674 188.533C95.8394 185.274 105.209 181.611 114.851 179.851C148.613 173.765 178.524 183.082 204.473 206.588C218.268 219.106 241.459 240.132 259.268 256.341C270.468 266.523 267.162 285.703 253.286 291.068C241.049 295.798 227.883 300.845 219.224 304.162C215.372 305.633 212.477 305.431 209.172 302.46C169.373 266.205 129.465 230.066 89.6115 193.897C88.4915 192.888 87.5355 191.648 84.6674 188.533Z",
    fill: "#00A3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.216 16.4299C188.084 1.20114 205.347 -5.17304 216.601 4.80644C226.763 13.8341 237.662 23.5252 244.299 29.3514C247.413 32.0914 248.943 34.8026 248.124 39.3597C238.153 94.766 228.32 150.23 218.432 205.665C218.268 206.531 217.858 207.367 217.53 208.319C216.765 208.261 216.001 208.434 215.618 208.117C181.692 180.428 164.62 144.462 170.985 98.977C174.044 77.1433 180.326 42.2728 185.216 16.4299Z",
    fill: "#FF8A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e1a3e2fa3087c7a57e94be8d47ee9576.svg";
export { ForwardRef as ReactComponent };